// 지역:APP_LOCALE, 언어:getLanguage()
export const LOCALES = {
  KO: 'ko',
  JA: 'ja',
};